<template>
  <v-dialog v-model="show" max-width="520" persistent>
    <v-card>
      <v-card-title>{{ $t("finance_new_invoice") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <v-row dense>
            <v-col cols="6">
              <date-picker
                v-model="form.date"
                singleDate
                :label="$t('finance_date')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="6">
              <date-picker
                v-model="form.dueDate"
                singleDate
                :label="$t('finance_due_date_label')"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <dropdown
            v-model="form.type"
            :items="typeOptions"
            item-text="label"
            item-value="value"
            :label="$t('finance_type_label')"
            :rules="[rules.required]"
          />
          <v-row dense>
            <v-col cols="6">
              <text-field
                v-model.number="form.amount"
                :label="$t('finance_amount_currency', { currency: restaurantCurrency })"
                type="number"
                kind="money"
                :rules="[rules.required, rules.positive]"
              />
            </v-col>
            <v-col cols="6">
              <text-field
                v-model.number="form.vat"
                :label="$t('finance_vat')"
                type="number"
                kind="money"
              />
            </v-col>
          </v-row>
          <text-field
            v-model="form.paymentMethod"
            :label="$t('finance_payment_method_label')"
            prependInnerIcon="mdi-credit-card-outline"
          />
          <text-field v-model="form.iban" label="IBAN" prependInnerIcon="mdi-bank-outline" />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">{{ $t("finance_cancel") }}</v-btn>
        <primary-button :loading="saving" @click="submit">{{ $t("finance_save") }}</primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { INVOICE_TYPE_META } from "../FinanceTabInvoices.vue";

const emptyForm = () => ({
  date: "",
  dueDate: "",
  type: "commission",
  amount: 0,
  vat: 0,
  paymentMethod: "",
  iban: "",
});

export default {
  name: "InvoiceFormDialog",

  props: {
    value: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },

  data() {
    return {
      valid: true,
      form: emptyForm(),
      rules: {
        required: (v) => (v !== null && v !== undefined && v !== "") || this.$t("finance_required_field"),
        positive: (v) => Number(v) > 0 || this.$t("finance_amount_must_be_positive"),
      },
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    // "correction" je zastarjela vrijednost (samo za prikaz starih faktura) -
    // ne nudi se za nove, po dokumentaciji ticket-a #223672 v2.
    typeOptions() {
      return Object.keys(INVOICE_TYPE_META)
        .filter((value) => value !== "correction")
        .map((value) => ({ value, label: this.$t(INVOICE_TYPE_META[value]) }));
    },
  },

  watch: {
    value(isOpen) {
      if (!isOpen) return;
      this.form = emptyForm();
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("save", {
        date: this.form.date,
        type: this.form.type,
        amount: Number(this.form.amount),
        due_date: this.form.dueDate,
        payment_method: this.form.paymentMethod || undefined,
        iban: this.form.iban || undefined,
        vat: this.form.vat ? Number(this.form.vat) : undefined,
      });
    },
  },
};
</script>
